import React from 'react'
import styled from 'styled-components'
import {ThemeProvider} from '@material-ui/core/styles'
import {rgba} from 'lib/color'
import {useToggle} from 'lib/toggle'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import {useTheme} from 'Event/template/NiftyFifty/Page'
import Bar from 'Event/template/NiftyFifty/Dashboard/RightPanel/Bar'
import RightPanelConfig from 'Event/template/NiftyFifty/Dashboard/RightPanel/RightPanelConfig'

export default function RightPanel(props: {
  children: React.ReactElement
  currentTab: number
  onChangeTab: (tab: number) => void
}) {
  const {rightPanel} = useNiftyFiftyTemplate()
  const template = useNiftyFiftyTemplate()
  const {flag: barConfigVisible, toggle: toggleBarConfig} = useToggle()
  const theme = useTheme()

  return (
    <>
      <EditModeOnly>
        <RightPanelConfig
          showing={barConfigVisible}
          onClose={toggleBarConfig}
        />
      </EditModeOnly>
      <ThemeProvider theme={theme}>
        <Box>
          <Editable onEdit={toggleBarConfig}>
            <Bar
              currentTab={props.currentTab}
              onChangeTab={props.onChangeTab}
              aria-label="niftyfifty right panel bar"
            />
          </Editable>
          <Body
            backgroundColor={rgba(
              rightPanel.backgroundColor,
              rightPanel.backgroundOpacity / 100,
            )}
            textColor={template.textColor}
            padding={template.rightPanel.padding}
          >
            {props.children}
          </Body>
        </Box>
      </ThemeProvider>
    </>
  )
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
`

const Body = styled.div<{
  backgroundColor: string
  textColor: string
  padding: number
}>`
  flex: 1;
  background: ${(props) => props.backgroundColor};
  position: relative;
  overflow: auto;
  padding: ${(props) => props.padding ?? '0'}px;

  > * {
    color: ${(props) => props.textColor} !important;
  }
`
